import { ACTIVE_TAB, LOADER_STATUS, FILE_DATA, SET_ENTITY_LIST, STORE_GSTIN_ITC04, STORE_PERIOD, PROFILE_DATA } from "./constants";

const initialState = {
    loaderStatus: false,
    activeTab: 1,
    fileData: [],
    filterDataJW:[],
    entityList:[],
    gstinList:[],
    entityMasterList:[],
    profileData:[],
    selectedGstin: '',
    // selectedPeriod: "",
    startDate: "",
    endDate: "",
}

const itc04Reducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
        case FILE_DATA:
            return {
              ...state,
              fileData:action.fileData
            }
    
        case ACTIVE_TAB:
            return{
                ...state,
                activeTab: action.activeTab
            }
            case SET_ENTITY_LIST:
        return {
          ...state,
          entityMasterList:action.payload
        }
        case STORE_GSTIN_ITC04:
          return {
            ...state,
            selectedGstin:action.selectedGstin
          }
          case STORE_PERIOD:
            return {
              ...state,
              startDate:action.date.startDate,
              endDate: action.date.endDate
            } 
            case PROFILE_DATA:
            return {
              ...state,
              profileData:action.profileData
            }
        default: return state
    }
}

export default itc04Reducer;